import { List } from 'immutable';
import { DesignTemplates } from 'records/DesignTemplate';
import BaseList from 'records/BaseList';

import {
  UPCOMING_OCCA_DESIGN_TEMPLATES_ASYNC_ACTION_START,
  UPCOMING_OCCA_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR,
  UPCOMING_OCCA_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS,
  UPCOMING_OCCA_DESIGN_TEMPLATES_RESET_STATE,
} from 'actions/upcomingOccaDesignTemplates';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [UPCOMING_OCCA_DESIGN_TEMPLATES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [UPCOMING_OCCA_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [UPCOMING_OCCA_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: DesignTemplates(action.data),
    });
  },
  [UPCOMING_OCCA_DESIGN_TEMPLATES_RESET_STATE]: () => {
    return initialState;
  },
};

export default function upcomingOccaDesignTemplates(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
